// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor_anchor__41IEi","visuallyHidden":"Anchor_visuallyHidden__XEw4H"};